package com.exura.features.demosets.domain.model

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("DemoSet")
data class DemoSet(

    @JsName("id")
    val id: String = "",

    @JsName("name")
    val name: String,

    @JsName("description")
    val description: String,

    @JsName("isHidden")
    val isHidden: Boolean = false,

    @JsName("accessCode")
    val accessCode: String? = null,

    @JsName("plans")
    val plans: Array<DemoSetPlanFacet> = emptyArray()
)
